import { render, staticRenderFns } from "./ArticleModeForm.vue?vue&type=template&id=07722955&scoped=true&"
import script from "./ArticleModeForm.vue?vue&type=script&lang=ts&"
export * from "./ArticleModeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07722955",
  null
  
)

export default component.exports